// Shared helper for the Results -> By User CSV export "scope" (bug826).
//
// The CSV export must contain ONLY the rows the admin is currently viewing
// after any active filter: the sidebar attribute/sentiment filter, the inline
// Question Filters (question+option / attempt number / drop-offs), the date
// range, the KC retake de-dup, and the FE-only hiding of messaging placeholder
// rows. This helper turns the already-resolved on-screen row list into the
// "scope" payload that BOTH export endpoints intersect against, so the logic
// lives in ONE place and both handlers stay identical.
//
// Contract:
//   - No filter active -> returns an EMPTY body `{}`. The caller sends no
//     scope key, so the BE runs its unchanged full-export path (byte-for-byte
//     identical to the pre-bug826 behavior).
//   - Filter active -> returns `{ submissionIds: [...] }` listing the visible
//     submission ids (the triviaResults `_id` of each displayed row). The
//     array may be EMPTY when a filter narrows the table to zero rows; the key
//     is still sent so the BE scopes to zero rows (headers only) instead of
//     falling back to a full export.
//
// `rows` MUST be the post-transform displayed set (e.g. `responsesData`) and
// never the raw fetch, so hidden placeholder rows and collapsed KC retakes
// never leak into the export.
export const buildExportScopeBody = (rows, isFilterActive) => {
  if (!isFilterActive) {
    return {};
  }

  const submissionIds = [];
  if (Array.isArray(rows)) {
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      const id = row && row._id ? row._id : null;
      if (id) {
        submissionIds.push(id);
      }
    }
  }

  return { submissionIds: submissionIds };
};
